import cn from "classnames";
import Address from "components/shared/address";
import { formatDateTimezone, getShortAddress } from "helpers/bidpoint";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import React from "react";

const BidsForParallelPoint = (props) => {
    const getAddress = (geozone) => <Address address={getShortAddress(geozone)} />;
    return (
        <div className="card card-info">
            <div className="card-header">
                Вы можете связать точку перецепки с заявкой. <br />
                <small>При выполнении перецепки заявки поменяются указанными составляющими.</small>
            </div>
            <div className="card-body">
                {props.items.map((item, i) => (
                    <div
                        key={item.id}
                        className={cn("row", {
                            "border-bottom": i !== props.items.length - 1,
                            "bg-light-primary": props.parallelBidId === item.id,
                        })}
                    >
                        <div className="col-sm-4 b-point__list-item py-2">
                            <div className="b-point__line">
                                <div className="d-flex position-relative">
                                    <div className="b-point__circle b-point__circle--start" />
                                    <div className="b-point__circle--line" />
                                    <di className="b-point__city">
                                        {getAddress(item.firstBidPoint.geozone)}
                                        <div className="small text-muted">
                                            {dateTimeToView(item.firstBidPoint.planEnterDateOffset)}{" "}
                                            {formatDateTimezone(item.firstBidPoint)}
                                        </div>
                                    </di>
                                </div>
                            </div>
                            <div className="b-point__line">
                                <div className="d-flex">
                                    <div className="b-point__circle" />
                                    <div className="b-point__city">
                                        {getAddress(item.lastBidPoint.geozone)}
                                        <div className="small text-muted">
                                            {dateTimeToView(item.lastBidPoint.planEnterDateOffset)}{" "}
                                            {formatDateTimezone(item.lastBidPoint)}
                                        </div>
                                        <a
                                            href={paths.bidShow("bid", item.id)}
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            className="mb-3"
                                        >
                                            Подробнее
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-3 small py-2">
                            <div>
                                <b className="pr-1">Машина:</b>
                                <span>{item.car?.number}</span>
                            </div>
                            <div>
                                <b className="pr-1">Водитель:</b>
                                <span>{item.driverName}</span>
                            </div>
                            {item.secondaryDriverName && (
                                <div>
                                    <b className="pr-1">Второй водитель:</b>
                                    <span>{item.secondaryDriverName}</span>
                                </div>
                            )}
                        </div>
                        <div className="col-sm-3 small py-2">
                            <b>Груз</b>
                            {item.cargos.map((cargo, i) => (
                                <div key={i}>{cargo.name}</div>
                            ))}
                        </div>
                        <div className="col-sm-2 small py-2">
                            <div
                                className={cn("inline-btn", {
                                    "inline-btn--delete": props.parallelBidId === item.id,
                                    "inline-btn--checkmark": props.parallelBidId !== item.id,
                                })}
                                onClick={props.selectPoint.bind(this, props.parallelBidId === item.id ? null : item.id)}
                            >
                                {props.parallelBidId === item.id ? "Снять выбор" : "Выбрать"}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BidsForParallelPoint;
